import React, { useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Badge,
  Button,
  Modal,
  ModalBody,
  UncontrolledTooltip,
} from "reactstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import helpers from "utils/helpers";
import SupportRequestDetails from "../support-tickets/SupportRequestDetails";

const OrderDetailsCard = ({ order }) => {
  const [viewTicket, setViewTicket] = useState(null);
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  if (!order) return null;

  const getStatus = (status) =>
    helpers.TICKET_STATUSES[status] || {
      text: `Unknown (${status || "n/a"})`,
      color: "warning",
    };

  const openTicketModal = (ticket) => {
    setViewTicket(ticket);
    setIsTicketModalOpen(true);
  };

  const closeTicketModal = () => {
    setIsTicketModalOpen(false);
    setViewTicket(null);
  };

  const { text, color } = getStatus(order.status);

  const traveler = order?.traveler_listing_id?.userId;
  const sender = order?.sender_listing_id?.userId;

  return (
  <>
    <Card className="shadow-md">
      <CardBody>
        <Row className="mb-3 align-items-center">
          <Col>
            <span className="text-muted">
              Order Details
            </span>
          </Col>
          <Button
            id={`view-order-${order._id}`}
            size="sm"
            color="link"
            className="mr-3 btn-secondary"
            onClick={() => openTicketModal(order)}
          >
            <VisibilityIcon fontSize="small" color="primary" />
          </Button>

          <UncontrolledTooltip target={`view-order-${order._id}`} trigger="hover">
            View More Details
          </UncontrolledTooltip>
          <Col className="col-auto">
            <Badge className="badge-lg" color={color}>
              {text}
            </Badge>
          </Col>
        </Row>

        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <span className="text-muted mb-1">Order ID</span>
            <h4>
              {order.orderid || "N/A"}
            </h4>
          </div>
        </div>

        <Row className="mb-3">
          <Col>
            <small className="text-muted mb-1">Traveler</small>
            <span className="d-block">
              {traveler?.firstName} {traveler?.lastName}
            </span>
            {traveler?.email && (
              <small className="text-muted">{traveler.email}</small>
            )}
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <small className="text-muted mb-1">Sender</small>
            <span className="d-block">
              {sender?.firstName} {sender?.lastName}
            </span>
            {sender?.email && (
              <small className="text-muted">{sender.email}</small>
            )}
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <small className="text-muted mb-1">Route</small>
            <span className="d-block">
              {order?.sender_listing_id?.fromPlace?.name} →{" "}
              {order?.sender_listing_id?.toPlace?.name}
            </span>
          </Col>
        </Row>

        <Row>
          <Col>
            <small className="text-muted mb-1">Journey Date</small>
            <span className="d-block">
              {new Date(
                order?.order_accepted_by === "sender"
                  ? order?.sender_listing_id?.date
                  : order?.traveler_listing_id?.date
              ).toLocaleDateString()}
            </span>
          </Col>
        </Row>
      </CardBody>
    </Card>
    <Modal
      isOpen={isTicketModalOpen}
      toggle={closeTicketModal}
      size="lg"
      backdrop="static"
      className="modal-dialog-centered"
    >
      <ModalBody className="p-0">
        {viewTicket && (
          <SupportRequestDetails
            ticketData={viewTicket}
            onClose={closeTicketModal}
          />
        )}
      </ModalBody>
    </Modal>
  </>
  );
};

export default OrderDetailsCard;
